import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sp-circular-progress',
  templateUrl: './circle-progress.component.html',
  styleUrls: ['./circle-progress.component.less'],
})
export class SpCircleProgressComponent implements OnInit {
  @Input() progress: number = 0;
  @Input() text: string = '';
  @Input() width: number = 275;
  @Input() height: number = 275;

  radius: number = 0;
  centerX: number = 0;
  centerY: number = 0;
  circumference: number = 0;
  fontSizeText: number = 18;
  fontSizeValue: number = 32;
  strokeWidth: number = 20;

  constructor() {
  }

  ngOnInit(): void {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  private updateDimensions(): void {
    const screenWidth = window.innerWidth;

    this.width = 275 * (screenWidth / 1920);
    this.height = this.width; // Maintain a square aspect ratio
    this.fontSizeText = 18 * (screenWidth / 1920)
    this.fontSizeValue = 18 * (screenWidth / 1920)
    this.strokeWidth = 18 * (screenWidth / 1920)

    this.centerX = this.width / 2;
    this.centerY = this.height / 2;
    this.radius = Math.min(this.width, this.height) / 2 - 20; // Assuming a stroke-width of 20, subtract 20 here to make sure the circle is completely inside the view
    this.circumference = 2 * Math.PI * this.radius;
  }
}
